import { appInfo } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 p-6 md:p-10 rounded-2xl bg-background-100 border border-background-200/70">
          <div className="flex-shrink-0">
            <div className="w-28 h-28 md:w-36 md:h-36 rounded-3xl bg-primary-500 flex items-center justify-center">
              <i className="ri-smartphone-line text-4xl md:text-5xl text-white"></i>
            </div>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-xl md:text-2xl font-extrabold text-foreground-950 mb-2">
              {appInfo.title}
            </h2>
            <p className="text-base md:text-lg text-primary-600 font-semibold mb-3">
              {appInfo.subtitle}
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5">
              {appInfo.desc}
            </p>
            <div className="flex flex-wrap justify-center lg:justify-start gap-2 mb-5">
              {appInfo.features.map((feat) => (
                <span
                  key={feat}
                  className="whitespace-nowrap px-3 py-1.5 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700"
                >
                  {feat}
                </span>
              ))}
            </div>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#app"
                className="whitespace-nowrap flex items-center gap-2 px-6 py-3 rounded-full bg-foreground-950 text-white text-sm font-semibold hover:bg-foreground-800 transition-colors cursor-pointer"
              >
                <i className="ri-apple-fill text-lg"></i>
                App Store
              </a>
              <a
                href="#app"
                className="whitespace-nowrap flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-android-fill text-lg"></i>
                Android 下载
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}